import { useAppSelector } from "integrations/redux/hooks"
import { Fragment, useMemo } from "react"
import { Marker } from "react-map-gl"
import { useTranslation } from "@nova/use-translation"
import { selectMapHotspots } from "features/entity-caching/hotspots/selectors"
import { selectFlightsWithHotspotLabels } from "features/entity-caching/flights/selectors"
import { useViewport } from "features/map/GlobalViewState"

const estimatedPixelsPerCharacter = 6.67
const estimtedTextHeight = 14

export const MapboxLabel = () => {
    const { t } = useTranslation()

    const visibleHotspots = useAppSelector(selectMapHotspots)
    const labelLayerShow = useAppSelector(selectFlightsWithHotspotLabels)
    const view = useViewport()

    const labels = useMemo(() => {
        const labels: { x: number; y: number; id: string; label: string }[] = []
        const sorted = Object.values(visibleHotspots)
            .filter((e) => labelLayerShow[e.flightId])
            .map(({ longitude, latitude, id, label }) => {
                const [x, y] = view.project([longitude, latitude])
                return { x, y, id, label }
            })
        for (let i = 0; i < sorted.length; i++) {
            const point = sorted[i]
            if (
                !labels.some(
                    (a) =>
                        Math.abs(a.x - point.x) < a.label.length * estimatedPixelsPerCharacter &&
                        Math.abs(a.y - point.y) < estimtedTextHeight
                )
            )
                labels.push(point)
        }
        return labels.map((point) => visibleHotspots[point.id])
    }, [visibleHotspots, labelLayerShow, view])

    return (
        <Fragment>
            {labels.map(({ longitude, latitude, label }, idx) => {
                return (
                    <Marker
                        latitude={latitude}
                        longitude={longitude}
                        anchor="left"
                        offset={[12, 0]}
                        key={idx}
                    >
                        <div
                            style={{
                                // eslint-disable-next-line @typescript-eslint/ban-ts-comment -- idk how else to disable the error
                                // @ts-ignore: next-line
                                "-webkit-text-stroke": "4.5px white",
                                // compatability list: https://caniuse.com/?search=-webkit-text-stroke
                                fontSize: 14,
                                fontWeight: 400,
                                transformOrigin: "left center",
                                paintOrder: "stroke fill",
                            }}
                        >
                            {t(label)}
                        </div>
                    </Marker>
                )
            })}
        </Fragment>
    )
}
